import React from "react";
import { connect } from "react-redux";
import Request, { API_URL } from '../../request'
import { Card, Row, Col, Button } from 'antd'
import moment from "moment";
import _ from 'lodash'
import Timer from "../Timer/Timer";
import { Link } from "react-router-dom";
import AddTask from '../TasksManagement/AddTask';

class PendingTask extends React.Component {
    state = {
        visible: true,
        withdrawReason: '',
        withdrawDate: '',
        showAddTaskForm: false,
        showTaskListForm: false,
        allUsers: [],
        weekendsVisible: true,
        currentEvents: [],
        allEvents: [],
        allTrainings: [],
        startDate: '',
        endDate: '',
        filterStatus: 'Pending',
        filterPriority: '',
        assignById: '',
        assignId: '',
        counsellors: [],
        localUser: {},
        trackAllUserAttendence: null
    }


    async getCompanyDetails() {
        let response = await Request.getCompanySetting({ businessId: this.state.localUser.businessId })

        this.setState({ trackAllUserAttendence: response.trackAllUserAttendence })
    }

    async componentDidMount() {
        let localUser = JSON.parse(localStorage.getItem("user"));
        let { data: allUsers } = await Request.loadDeskUser({
            results: 10000,
            active: true,
            userBranch: localUser ? localUser.userBranch : null,
            userId: localUser._id,
        });

        this.setState({ allUsers: allUsers, assignId: localUser._id, localUser: localUser });
        this.getCompanyDetails()
        this.getCalendarData()
        this.getAssignedTrainings()

    }

    addNewTask = () => {
        this.setState({ showAddTaskForm: true })
    }

    getAssignedTrainings = async () => {
        let startDate = moment().format('YYYY-MM-DD')
        let endDate = moment().format('YYYY-MM-DD')
        this.setState({ startDate, endDate })
        let params = {};

        let response = await Request.getAllAssignedTrainings(params)
        this.setState({ allTrainings: response.data })
    }

    closeDocument = () => {
        this.setState({
            showAddTaskForm: false,
        })
    }

    getCalendarData = async () => {
        let startDate = moment().format('YYYY-MM-DD')
        let endDate = moment().format('YYYY-MM-DD')

        this.setState({ startDate, endDate })
        let params = {};

        // params.dueDate = {
        //     $gte: startDate,
        //     $lte: endDate
        // };
        if (this.state.filterStatus) {
            params.status = this.state.filterStatus
        }
        if (this.state.filterPriority) {
            params.priority = this.state.filterPriority
        }
        if (this.state.assignById) {
            params.assignById = this.state.assignById
        }
        if (this.state.assignId) {
            params.assignId = this.state.assignId
        }
        let response = await Request.getAllTaskListAssignToUser(params);
        let events = [];
        if (response && response.data && response.data.length) {
            _.each(response.data, (event) => {
                const startDateTime = moment(event.startDate).format('YYYY-MM-DD') + ' ' + event.startTime
                events.push({
                    id: event._id,
                    title: event.taskTitle,
                    assignedBy: event.createdByUser && event.createdByUser.name,
                    priority: event.priority,
                    status: event.status,
                    start: (event.startDate ? startDateTime : event.dueDate),
                    dueDate: event.dueDate
                })
            })
        }
        this.setState({ allEvents: events });
    }

    render() {
        console.log(this.state.trackAllUserAttendence);
        let { allEvents, allTrainings, showAddTaskForm, allUsers } = this.state
        return (
            <div>
                {
                    showAddTaskForm ?
                        <AddTask allUsers={allUsers} onClose={this.closeDocument} />
                        : null
                }
                <Row gutter={16} style={{ marginBottom: "20px" }}>
                    {this.state.trackAllUserAttendence ?
                        <Col span={12}>
                            <Timer />
                        </Col>
                        : null}
                    <Col span={this.state.trackAllUserAttendence ? 12 : 24} >
                        {/* <Card bordered={true} title="Pending Tasks" extra={<div> <a onClick={this.addNewTask} style={{ marginLeft: 10 }}>Add Task</a> | <Link to="/task">View All</Link> </div>} >
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td>Task Name</td>
                                        <td>Priority</td>
                                        <td>Assigned By</td>
                                        <td>Start Date</td>
                                        <td>Due Date</td>
                                    </tr>
                                    {allEvents.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.title}</td>
                                            <td>{item.priority}</td>
                                            <td>{item.assignedBy}</td>
                                            <td>{moment(item.start).format('DD MMMM YYYY')}</td>
                                            <td>{moment(item.dueDate).format('DD MMMM YYYY')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Card> */}
                        {/* <Card bordered={true} title="Trainings" style={{ marginTop: '10px' }} >
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td>University</td>
                                        <td>Date</td>
                                        <td>Time</td>
                                        <td>Training Type</td>
                                        <td>Link/Location</td>
                                        <td>MeetingId/Password</td>
                                    </tr>
                                    {allTrainings.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.university && item.university.universityInstitutionName ? item.university.universityInstitutionName : item.universityName}</td>
                                            <td>{moment(item.date).format('DD MMMM YYYY')}</td>
                                            <td>{item.time}</td>
                                            <td>{item.trainingType}</td>
                                            <td>{item.meetingLink ? <Button type="primary" target="_blank" href={item.meetingLink}>Join Meeting</Button> : item.meetingLocation}</td>
                                            <td>{item.meetingLink && (item.meetingId || item.meetingPassword) ? `${item.meetingId ? item.meetingId : ""}/${item.meetingPassword ? item.meetingPassword : ''}` : ''}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Card> */}
                    </Col>
                    {/* {this.state.trackAllUserAttendence ?
                        <Col span={124}>
                            <Timer />
                        </Col>
                        : null} */}
                </Row>

            </div>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PendingTask)